module.exports = __webpack_public_path__ + "static/img/release-success.e80f6521.png";